module.exports = new __parcel__URL__("progress-default--dark.1f84bbff.svg").toString();